import { Injectable } from '@angular/core';
import { SuchparameterService } from '../../core/services/suchparameter.service';
import { SearchMode } from '../enum/searchMode';

@Injectable()
export class SearchStateService {
  _lastRequest;
  _lastSearchMode: SearchMode;
  _lastSearchTerm: string;

  constructor(private suchparameterService: SuchparameterService) {}

  private resetIfneeded() {
    if (this.suchparameterService.shouldResetLastRequest()) {
      this.lastSearchMode = null;
      this.lastRequest = null;
    }
  }

  get lastSearchMode() {
    this.resetIfneeded();
    return this._lastSearchMode;
  }

  set lastSearchMode(value) {
    this._lastSearchMode = value;
  }

  get lastRequest() {
    this.resetIfneeded();
    return this._lastRequest;
  }

  set lastRequest(value) {
    this._lastRequest = value;
  }

  get lastSearchTerm(): string {
    return this._lastSearchTerm;
  }

  set lastSearchTerm(value: string) {
    this._lastSearchTerm = value;
  }
}
